import React, { useEffect, useState, useMemo } from "react";
import { Form, Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import Loader from '../../component/loader';
import { BiCategory } from "react-icons/bi";
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import { Modal } from "react-bootstrap";
import Cookies from 'js-cookie';
import { decrpt } from '../../component/encryption';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Category() {
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState();
  const [statusShow, setStatusShow] = useState(false);
  const [status, setStatus] = useState(false);
  const [Eshow, setEShow] = useState(false);
  const [dshow, setDShow] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [category, setcategory] = useState([]);
  const [categoryPreview, setCategoryPreview] = useState({
    image: '',
    banner_image: ''
  });
  const [editCategory, setEditCategory] = useState();
  const [newCategory, setNewCategory] = useState({
    id: '',
    name: '',
    category_id: '',
    level: '1',
    image: '',
    banner_image: '',
    commission: '',
  });
  const [categorySelected, setCategorySelected] = useState({
    id: '',
    name: '',
    level: 1,
    image: '',
    banner_image: '',
    commission: '',
  });

  // Pagination & Search states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const handleOpen = () => {
    setShow(true);
    setCategoryPreview({
      image: '',
      banner_image: ''
    });
    setErrors();
  };

  const handleClose = () => {
    setShow(false);
  };

  const editCall = (item) => {
    setEditCategory(item);
    setNewCategory(item);
    setCategorySelected({
      ...categorySelected,
      id: item.id,
      name: item.name,
      level: '1',
      image: item.image,
      banner_image: item.banner_image,
      commission: item.commission,
    });
    setErrors();
    setEShow(true);
  };

  const handleCloseEdit = () => {
    setEShow(false);
  };

  const textHandler = (e) => {
    setNewCategory({ ...newCategory, name: e.target.value });
  };

  function handlePreview(e) {
    if (e.target.files && e.target.files[0]) {
      setCategoryPreview({ ...categoryPreview, image: URL.createObjectURL(e.target.files[0]) });
      setNewCategory({ ...newCategory, image: e.target.files[0] });
    }
  }

  function handleEditPreview(e) {
    if (e.target.files && e.target.files[0]) {
      setCategoryPreview({ ...categoryPreview, image: URL.createObjectURL(e.target.files[0]) });
      setCategorySelected({ ...categorySelected, image: e.target.files[0] });
    }
  }

  function handleEditBannerPreview(e) {
    if (e.target.files && e.target.files[0]) {
      setCategoryPreview({ ...categoryPreview, banner_image: URL.createObjectURL(e.target.files[0]) });
      setCategorySelected({ ...categorySelected, banner_image: e.target.files[0] });
    }
  }

  function handleBannerPreview(e) {
    if (e.target.files && e.target.files[0]) {
      setCategoryPreview({ ...categoryPreview, banner_image: URL.createObjectURL(e.target.files[0]) });
      setNewCategory({ ...newCategory, banner_image: e.target.files[0] });
    }
  }

  // Get Category List
  const getCategoryList = async () => {
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/list`, { type: 1 });
      if (response.data?.success && response.data?.data) {
        let list = response.data.data.list || [];
        const pagination = response.data.data.pagination;
        if (pagination && pagination.total_pages > 1 && list.length < pagination.total_data) {
          const pagePromises = [];
          for (let p = 2; p <= pagination.total_pages; p++) {
            pagePromises.push(axios.post(`admin/category/list?page=${p}`, { type: 1 }));
          }
          const extraResponses = await Promise.all(pagePromises);
          extraResponses.forEach((res) => {
            if (res.data?.success && res.data?.data?.list) {
              list = list.concat(res.data.data.list);
            }
          });
        }
        setcategory(list);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  // Filtered categories by search
  const filteredCategories = useMemo(() => {
    if (!Array.isArray(category)) return [];
    if (!searchText.trim()) return category;
    const q = searchText.trim().toLowerCase();
    return category.filter((c) => {
      const name = (c.name || "").toLowerCase();
      const id = String(c.id || "").toLowerCase();
      const commission = String(c.commission || "").toLowerCase();
      return name.includes(q) || id.includes(q) || commission.includes(q);
    });
  }, [category, searchText]);

  // Pagination logic
  const totalItems = filteredCategories.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  // Keep currentPage within valid range whenever totalPages or itemsPerPage changes
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedCategories = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredCategories.slice(startIndex, endIndex);
  }, [filteredCategories, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // Add Category
  const addCategory = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("level", newCategory.level);
    formData.append("name", newCategory.name);
    formData.append("image", newCategory.image);
    formData.append("banner_image", newCategory.banner_image);
    formData.append("commission", newCategory.commission);

    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/save`, formData);
      if (response.data.success) {
        handleClose();
        let newData = response.data.data;
        setcategory((prev) => (Array.isArray(prev) ? [newData, ...prev] : [newData]));
        setEShow(false);
        setLoader(false);
        toast.success("Category Added", { hideProgressBar: true });
      }
    } catch (err) {
      setLoader(false);
      console.error('Error', err);
      setErrors(err.response?.data?.errors);
      toast.error("Something went wrong", { hideProgressBar: true });
      setEShow(true);
    }
  };

  const editCategoryUpdate = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("id", categorySelected.id);
    formData.append("level", categorySelected.level);
    formData.append("name", categorySelected.name);

    if (typeof categorySelected.image !== 'string') {
      formData.append("image", categorySelected.image);
    }

    if (typeof categorySelected.banner_image !== 'string') {
      formData.append("banner_image", categorySelected.banner_image);
    }

    formData.append("commission", categorySelected.commission);

    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/save`, formData);
      let newData = response.data.data;
      setcategory((prev) => {
        if (!Array.isArray(prev)) return [newData];
        return prev.map((item) => (item.id === newData.id ? { ...item, ...newData } : item));
      });
      setLoader(false);
      setEShow(false);
      toast.success("Category Updated", { hideProgressBar: true });
    } catch (error) {
      setErrors(error.response?.data?.errors);
      setLoader(false);
      toast.error("Something went wrong", { hideProgressBar: true });
    }
  };

  // Change Category State
  const handleStatus = (item) => {
    setStatusShow(true);
    setStatus(item);
  };

  const handleStatusClose = () => {
    setStatusShow(false);
  };

  const statusUpdate = async () => {
    setLoader(true);
    let newstatus = status.status == 1 ? 2 : 1;
    const data = {
      id: status.id,
      status: newstatus,
    };
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      await axios.post(`/admin/category/status`, data);
      setcategory((prev) => {
        if (!Array.isArray(prev)) return [];
        return prev.map((item) => (item.id === status.id ? { ...item, status: newstatus } : item));
      });
      toast.success("Category Status Updated", { hideProgressBar: true });
      setLoader(false);
      setStatusShow(false);
    } catch (error) {
      toast.error("Failed to update Category Status", { hideProgressBar: true });
      setLoader(false);
    }
  };

  const handleCloseDelete = () => {
    setDShow(false);
    setDeleteItem(null);
  };

  const handleDelete = (item) => {
    setDeleteItem(item);
    setDShow(true);
  };

  const confirmDeleteCategory = async () => {
    if (!deleteItem) return;
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/category/delete`, { id: deleteItem.id });
      if (response.data?.success) {
        setcategory((prev) => (Array.isArray(prev) ? prev.filter((c) => c.id !== deleteItem.id) : []));
        toast.success("Category Deleted Successfully", { hideProgressBar: true });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to delete category", { hideProgressBar: true });
    } finally {
      setDShow(false);
      setDeleteItem(null);
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategoryList();
  }, []);

  return (
    <div className="main-content">
      {loader ? (
        <Loader />
      ) : (
        <>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={'colored'}
          />
          {/* Category List */}
          <div className="section">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h5>
                    <BiCategory className="me-1" />
                    All 1st Level Category
                  </h5>
                </div>
                <div className="card p-2 mt-3">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="mb-0">You have {totalItems} category</h5>
                      <Button onClick={() => handleOpen()} className="badge btn-xs pt-1">
                        Add New 1st Level Category
                      </Button>
                    </div>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Name, ID, Commission..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>1st Level Category</th>
                          <th>Commission</th>
                          <th>Category Image</th>
                          <th>Category Banner</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedCategories && paginatedCategories.length > 0 ? (
                          paginatedCategories.map((item, index) => {
                            return (
                              <tr key={item.id || index}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                <td>{item.name}</td>
                                <td>{item.commission ? item.commission + '%' : '-'}</td>
                                <td>
                                  {item.image ? (
                                    <img src={item.image} alt={item.name} style={{ width: 100, height: 100, objectFit: 'cover' }} />
                                  ) : (
                                    <span className="text-muted">No Image</span>
                                  )}
                                </td>
                                <td>
                                  {item.banner_image ? (
                                    <img src={item.banner_image} alt={item.name} style={{ width: 100, height: 100, objectFit: 'cover' }} />
                                  ) : (
                                    <span className="text-muted">No Banner</span>
                                  )}
                                </td>
                                <td className="text-center">
                                  {item && item.status == 1 ? (
                                    <Badge bg="success">Enable</Badge>
                                  ) : (
                                    <Badge bg="danger">Disable</Badge>
                                  )}
                                </td>
                                <td className="text-center">
                                  <button onClick={() => editCall(item)} className="btn btn-xs btn-primary text-white me-1">
                                    Edit
                                  </button>
                                  {item && item.status == 1 ? (
                                    <button onClick={() => handleStatus(item)} className="btn btn-xs btn-secondary text-white me-1">
                                      Make Disable
                                    </button>
                                  ) : (
                                    <button onClick={() => handleStatus(item)} className="btn btn-xs btn-success text-white me-1">
                                      Make Enable
                                    </button>
                                  )}
                                  <button type="button" onClick={() => handleDelete(item)} className="btn btn-xs btn-danger text-white">
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div
                        className="flex items-center justify-between mt-4 px-2"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginTop: '1rem',
                          padding: '0 0.5rem',
                          flexWrap: 'wrap',
                          gap: '0.75rem',
                        }}
                      >
                        <div
                          className="flex items-center gap-2"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                            Show
                          </span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{
                              padding: '0.25rem 0.5rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              outline: 'none',
                              background: '#fff',
                            }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                            entries
                          </span>
                        </div>

                        <div
                          className="flex items-center gap-2"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === 1 ? 0.5 : 1,
                              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                            }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span
                            className="text-sm font-medium px-2 text-gray-700"
                            style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}
                          >
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === totalPages ? 0.5 : 1,
                              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                            }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to{' '}
                          {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Add Category Modal */}
                  <Modal size="md" show={show} onHide={handleClose}>
                    <Modal.Header className="py-1" closeButton>
                      <Modal.Title>Add 1st Level Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Category Image* </Form.Label>
                          <Form.Control type="file" onChange={handlePreview} />
                          {errors && errors.image ? <p style={{ fontSize: 12, color: 'red' }}> {errors.image} </p> : ''}
                        </Form.Group>
                        <img
                          src={categoryPreview && categoryPreview.image !== '' ? categoryPreview.image : '/folder.png'}
                          alt="preview"
                          style={{ width: 100, height: 100 }}
                        />

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                          <Form.Label>Category banner Image* </Form.Label>
                          <Form.Control type="file" onChange={handleBannerPreview} />
                          {errors && errors.banner_image ? (
                            <p style={{ fontSize: 12, color: 'red' }}> {errors.banner_image} </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>
                        <img
                          src={
                            categoryPreview && categoryPreview.banner_image !== ''
                              ? categoryPreview.banner_image
                              : '/folder.png'
                          }
                          alt="preview"
                          style={{ width: 100, height: 100 }}
                        />

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
                          <Form.Label>1st Level Category*</Form.Label>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="Enter 1st Level Category"
                            onChange={(e) => textHandler(e)}
                          />
                          {errors && errors.name ? <p style={{ fontSize: 12, color: 'red' }}> {errors.name} </p> : ''}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
                          <Form.Label>Commission (%)*</Form.Label>
                          <Form.Control
                            size="sm"
                            type="number"
                            placeholder="Enter Commission Percentage"
                            onChange={(e) => setNewCategory({ ...newCategory, commission: e.target.value })}
                          />
                          {errors && errors.commission ? (
                            <p style={{ fontSize: 12, color: 'red' }}> {errors.commission} </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleClose()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button type="button" onClick={() => addCategory()} className="btn btn-primary btn-sm">
                        Save Changes
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Status Category Modal */}
                  <Modal size="md" show={statusShow} onHide={handleStatus} centered>
                    <Modal.Header className="py-1">
                      <Modal.Title className="h6">
                        Do you want to {status && status.status == 1 ? 'Disable' : 'Enable'} category ? <br />
                        <span className="text-danger text-capitalize fw-bold">{status && status.name}</span>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleStatusClose()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button className="btn btn-primary btn-sm" onClick={() => statusUpdate()}>
                        {status && status.status == 1 ? 'Make Disable' : 'Make Enable'}
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Edit Category Modal */}
                  <Modal size="md" show={Eshow} onHide={handleCloseEdit}>
                    <Modal.Header className="py-1" closeButton>
                      <Modal.Title>Edit 1st Level Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput5">
                        <Form.Label>Category Image </Form.Label>
                        <Form.Control type="file" onChange={handleEditPreview} />
                        {errors && errors.image ? <p style={{ fontSize: 12, color: 'red' }}> {errors.image} </p> : ''}
                      </Form.Group>
                      <img
                        src={
                          categoryPreview && categoryPreview.image !== ''
                            ? categoryPreview.image
                            : categorySelected.image
                        }
                        alt="preview"
                        style={{ width: 100, height: 100 }}
                      />

                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput6">
                        <Form.Label>Category banner Image </Form.Label>
                        <Form.Control type="file" onChange={handleEditBannerPreview} />
                        {errors && errors.banner_image ? (
                          <p style={{ fontSize: 12, color: 'red' }}> {errors.banner_image} </p>
                        ) : (
                          ''
                        )}
                      </Form.Group>
                      <img
                        src={
                          categoryPreview && categoryPreview.banner_image !== ''
                            ? categoryPreview.banner_image
                            : categorySelected.banner_image
                        }
                        alt="preview"
                        style={{ width: 100, height: 100 }}
                      />

                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput7">
                        <Form.Label>1st Level Category Name </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          placeholder="Enter Category Name"
                          onChange={(e) => setCategorySelected({ ...categorySelected, name: e.target.value })}
                          defaultValue={categorySelected && categorySelected.name}
                        />
                        {errors && errors.name ? <p style={{ fontSize: 12, color: 'red' }}> {errors.name} </p> : ''}
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput8">
                        <Form.Label>Commission (%) </Form.Label>
                        <Form.Control
                          size="sm"
                          type="number"
                          placeholder="Enter Commission Percentage"
                          onChange={(e) => setCategorySelected({ ...categorySelected, commission: e.target.value })}
                          defaultValue={categorySelected && categorySelected.commission}
                        />
                        {errors && errors.commission ? (
                          <p style={{ fontSize: 12, color: 'red' }}> {errors.commission} </p>
                        ) : (
                          ''
                        )}
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleCloseEdit()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button type="button" onClick={() => editCategoryUpdate()} className="btn btn-primary btn-sm">
                        Save Changes
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Delete Category Modal */}
                  <Modal size="md" show={dshow} onHide={handleCloseDelete} centered>
                    <Modal.Header closeButton>
                      <Modal.Title className="h6 fw-bolder">Delete Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete category <strong>{deleteItem?.name}</strong>?
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-end">
                      <button onClick={handleCloseDelete} className="btn btn-light btn-sm">
                        Cancel
                      </button>
                      <button onClick={confirmDeleteCategory} className="btn btn-danger btn-sm">
                        Delete
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Category;
